import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDenyOauthConsentArgs,
  BackendOAuthConsentResult,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DenyOAuthConsent($authorizeUrl: String!) {
    denyOauthConsent(authorizeUrl: $authorizeUrl) {
      redirectUrl
    }
  }
`;

type Variables = BackendMutationDenyOauthConsentArgs;
type Result = BackendOAuthConsentResult;

export const denyOAuthConsent = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
